import Grid from '@material-ui/core/Grid';
import { FacebookShareButton, FacebookIcon, EmailIcon } from 'react-share';
import ShareButton from 'react-share/lib/ShareButton';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { baseTheme } from '../../../theme';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    shareButton: {
      backgroundColor: '#747474',
      border: 'none',
      padding: '0px',
      font: 'inherit',
      color: 'inherit',
      cursor: 'pointer',
      height: '64px',
      width: '64px',
    },
  }),
);
export default function ShareModal(props: any) {
  const { post, isOpen, closeShareModal } = props;
  const classes = useStyles(baseTheme);
  const siteUrl = 'https://relyht-staging.firebaseapp.com';
  const generateShareLink = () => {
    if (!(post && post.id)) {
      return siteUrl;
    }
    return `${siteUrl}/shared/${post.id}`;
  };
  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(generateShareLink());
    closeShareModal();
  };
  return (
        isOpen &&
            <React.Fragment>
                <Typography>
                    Link to share:
                </Typography>
                <Typography onClick={copyLinkToClipboard}>
                    {generateShareLink()}
                </Typography>
                <Grid>
                    <FacebookShareButton
                      url={generateShareLink()}
                      quote={post.text}
                      onShareWindowClose={closeShareModal}
                    >
                        <FacebookIcon />
                    </FacebookShareButton>
                </Grid>
            </React.Fragment>
  );
}
